module.exports = __webpack_public_path__ + "static/media/bg-modal-desligamento.6d6c0635.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/bg-modal-desligamento.png
// module id = 621
// module chunks = 0